import React, { useContext } from 'react';
import { GeoJSON } from 'react-leaflet';
import { isNil } from 'lodash';

import { HabitatsContext } from 'containers/Habitats';

const ShapeFile = () => {
  const { state } = useContext(HabitatsContext);
  const { shapeData } = state;
  const noShapeData = isNil(shapeData);
  if (noShapeData) return null;
  const key = Math.random()
    .toString(36)
    .substr(2, 5);
  return <GeoJSON key={key} data={shapeData} />;
};

export default ShapeFile;
